import React from 'react'
import { useMutation } from 'react-query'
import { postCheckPhoneDeliverability } from '../api'
import { ERROR_CHECK_PHONE_DELIVERABILITY } from '../errorConstants'
import * as Sentry from '@sentry/react'

const useCheckPhoneDeliverability = () => {
    const { mutate, mutateAsync, data, error, isLoading, isSuccess, isError } =
        useMutation(postCheckPhoneDeliverability, {
            onError: (error) => {
                error.name = ERROR_CHECK_PHONE_DELIVERABILITY
                Sentry.captureException(error, {
                    contexts: {
                        data: {
                            errorMessage: ERROR_CHECK_PHONE_DELIVERABILITY,
                        },
                    }
                })
            },
        })
    return { mutate, mutateAsync, data, error, isLoading, isSuccess, isError }
}

export default useCheckPhoneDeliverability
